/* ═══════════════════════════════════════════════════════════
   Header Component — StratOS Premium Theme
   Mobile menu · Mega menu · Search · Cart · Sticky · Editorial
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var header = document.querySelector('.header');
  if (!header) return;

  /* ─────────────────────────────────────
     Mobile menu (drawer)
  ───────────────────────────────────── */
  var menuToggle = header.querySelector('[data-mobile-menu-toggle]');
  var mobileNav  = header.querySelector('.mobile-nav');
  var menuClose  = header.querySelector('[data-mobile-menu-close]');

  // Téléporter le mobile-nav dans <body> pour échapper au containing-block
  // créé par le parent sticky/transformed (#shopify-section-xxx).
  // Un position:fixed à l'intérieur d'un ancêtre transformé est positionné
  // par rapport à cet ancêtre, pas le viewport — ce qui casse le plein-écran.
  if (mobileNav) {
    // Nettoyer un éventuel nav orphelin laissé par un rechargement de section
    document.querySelectorAll('body > .mobile-nav').forEach(function (old) {
      if (old !== mobileNav) old.remove();
    });
    if (mobileNav.parentNode !== document.body) {
      document.body.appendChild(mobileNav);
    }
  }

  function openMobileMenu() {
    if (!mobileNav) return;
    mobileNav.removeAttribute('hidden');
    mobileNav.style.visibility = '';
    document.body.style.overflow = 'hidden';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    if (menuClose)  menuClose.focus();
  }

  function closeMobileMenu() {
    if (!mobileNav) return;
    mobileNav.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.focus();
    }
  }

  function trapMobileNav(e) {
    if (e.key === 'Escape') { closeMobileMenu(); return; }
    if (e.key !== 'Tab') return;
    var focusable = Array.from(mobileNav.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return !el.closest('[hidden]') && el.offsetParent !== null; });
    if (!focusable.length) { e.preventDefault(); return; }
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey ? document.activeElement === first : document.activeElement === last) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    }
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (menuClose)  menuClose.addEventListener('click', closeMobileMenu);
  if (mobileNav)  mobileNav.addEventListener('keydown', trapMobileNav);

  /* ─────────────────────────────────────
     Expanding search (handled by <expanding-search> custom element)
  ───────────────────────────────────── */
  if (!customElements.get('expanding-search')) {
    customElements.define('expanding-search', class extends HTMLElement {
      connectedCallback() {
        this._iconBtn  = this.querySelector('.header-search__icon-btn');
        this._field    = this.querySelector('.header-search__field');
        this._input    = this.querySelector('.header-search__input');
        this._closeBtn = this.querySelector('.header-search__close');
        this._mobileDialog = document.querySelector('[data-mobile-search-dialog]');

        this._iconBtn  && this._iconBtn.addEventListener('click',  this._open.bind(this));
        this._closeBtn && this._closeBtn.addEventListener('click', this._close.bind(this));

        if (this._mobileDialog) {
          var mCloseBtn = this._mobileDialog.querySelector('[data-mobile-search-close]');
          mCloseBtn && mCloseBtn.addEventListener('click', this._closeMobile.bind(this));
          this._mobileDialog.addEventListener('close', this._onMobileClose.bind(this));
        }

        document.addEventListener('click',   this._onOutside.bind(this));
        document.addEventListener('keydown', this._onKeydown.bind(this));
      }

        _open() {
        /* Mobile : modale native (top layer — aucun problème de z-index) */
        if (window.matchMedia('(max-width: 767px)').matches && this._mobileDialog) {
          this._mobileDialog.showModal();
          var inp = this._mobileDialog.querySelector('.mobile-search-dialog__input');
          if (inp) setTimeout(function () { inp.focus(); }, 80);
          return;
        }
        /* Desktop : expanding inline */
        this.classList.add('is-open');
        this._iconBtn.setAttribute('aria-expanded', 'true');
        this._field.removeAttribute('aria-hidden');
        if (this._input) {
          this._input.removeAttribute('tabindex');
          setTimeout(function () { this._input.focus(); }.bind(this), 50);
        }
      }

      _close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this._iconBtn && this._iconBtn.setAttribute('aria-expanded', 'false');
        this._field   && this._field.setAttribute('aria-hidden', 'true');
        if (this._input) this._input.setAttribute('tabindex', '-1');
        var results = this.querySelector('[data-predictive-results]');
        if (results) results.setAttribute('hidden', '');
        this._iconBtn && this._iconBtn.focus();
      }

      _closeMobile() {
        this._mobileDialog && this._mobileDialog.close();
      }

      _onMobileClose() {
        var inp = this._mobileDialog.querySelector('.mobile-search-dialog__input');
        if (inp) inp.value = '';
        var results = this._mobileDialog.querySelector('[data-predictive-results]');
        if (results) results.setAttribute('hidden', '');
      }

      _onOutside(e) {
        if (!this.contains(e.target)) this._close();
      }

      _onKeydown(e) {
        if (e.key === 'Escape') this._close();
      }

      disconnectedCallback() {
        document.removeEventListener('click',   this._onOutside.bind(this));
        document.removeEventListener('keydown', this._onKeydown.bind(this));
      }
    });
  }

  /* ─────────────────────────────────────
     Cart toggle (drawer ou page)
  ───────────────────────────────────── */
  var cartToggle = header.querySelector('[data-cart-toggle]');
  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      if (document.body.dataset.cartType === 'drawer') {
        e.preventDefault();
        window.pubsub && window.pubsub.publish('cart:open');
      }
    });
  }

  /* Mise à jour du compteur panier (bus pubsub + CustomEvent document) */
  var cartCountEl = header.querySelector('[data-cart-count]');

  function updateCartCount(count) {
    if (!cartCountEl) return;
    cartCountEl.textContent = count;
    cartCountEl.classList.toggle('is-hidden', count === 0);
    /* Animation bump */
    cartCountEl.classList.remove('cart-count--bump');
    void cartCountEl.offsetWidth; /* reflow pour relancer l'animation */
    if (count > 0) cartCountEl.classList.add('cart-count--bump');
  }

  window.pubsub && window.pubsub.subscribe('cart:updated', function (data) {
    if (data && typeof data.item_count !== 'undefined') updateCartCount(data.item_count);
  });

  /* ─────────────────────────────────────
     Mega menu — hover + clavier
  ───────────────────────────────────── */
  var megaTriggers = header.querySelectorAll('[data-mega-trigger]');

  megaTriggers.forEach(function (trigger) {
    var item  = trigger.closest('.header__nav-item--mega');
    var panel = item ? item.querySelector('[data-mega-panel]') : null;
    if (!item || !panel) return;

    var closeTimer = null;

    function openMega() {
      clearTimeout(closeTimer);
      panel.setAttribute('data-mega-open', '');
      trigger.setAttribute('aria-expanded', 'true');

      /* Style éditorial : activer le premier groupe par défaut */
      var firstGroup = panel.querySelector('[data-editorial-group]');
      if (firstGroup) setActiveEditorialGroup(panel, firstGroup);
    }

    function closeMega() {
      closeTimer = setTimeout(function () {
        panel.removeAttribute('data-mega-open');
        trigger.setAttribute('aria-expanded', 'false');
        clearEditorialGroups(panel);
      }, 160);
    }

    item.addEventListener('mouseenter', openMega);
    item.addEventListener('mouseleave', closeMega);
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', closeMega);

    /* Clavier */
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        panel.hasAttribute('data-mega-open') ? closeMega() : openMega();
      }
      if (e.key === 'Escape') { closeMega(); trigger.focus(); }
    });

    /* Style éditorial : hover sur les groupes */
    var editorialGroups = panel.querySelectorAll('[data-editorial-group]');
    editorialGroups.forEach(function (group) {
      group.addEventListener('mouseenter', function () {
        setActiveEditorialGroup(panel, group);
      });
    });
  });

  function setActiveEditorialGroup(panel, activeGroup) {
    var groups = panel.querySelectorAll('[data-editorial-group]');
    groups.forEach(function (g) { g.classList.remove('is-active'); });
    activeGroup.classList.add('is-active');
  }

  function clearEditorialGroups(panel) {
    panel.querySelectorAll('[data-editorial-group]').forEach(function (g) {
      g.classList.remove('is-active');
    });
  }

  /* ─────────────────────────────────────
     Sticky scroll effects
     Le position:sticky est appliqué directement en CSS via {% style %} dans header.liquid.
     JS gère uniquement : ombre au scroll + masquage smart sticky.
  ───────────────────────────────────── */
  (function () {
    var mode = header.dataset.sticky || 'false';
    if (mode === 'false') return;

    var sectionEl = header.closest('.site-header-wrapper') || header.parentElement;
    if (!sectionEl) return;

    var lastY        = window.scrollY;
    var ticking      = false;
    var threshold    = sectionEl.offsetHeight || 64;
    var floatingCart = document.getElementById('floating-cart');

    /* Sync compteur floating cart via pubsub */
    if (floatingCart) {
      var floatingCount = floatingCart.querySelector('.floating-cart__count');
      window.pubsub && window.pubsub.subscribe('cart:updated', function (data) {
        if (!data || typeof data.item_count === 'undefined') return;
        if (floatingCount) {
          floatingCount.textContent = data.item_count;
          floatingCount.classList.toggle('is-hidden', data.item_count === 0);
        }
      });
      /* Ouvrir le drawer au clic sur le floating cart */
      floatingCart.addEventListener('click', function () {
        if (document.body.dataset.cartType === 'drawer') {
          window.pubsub && window.pubsub.publish('cart:open');
        } else {
          window.location.href = window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.cart
            : '/cart';
        }
      });
    }

    function setFloatingCart(visible) {
      if (!floatingCart) return;
      floatingCart.classList.toggle('floating-cart--visible', visible);
      floatingCart.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;

        /* Ombre pleine largeur quand scrollé */
        sectionEl.classList.toggle('header--scrolled', y > 10);

        /* Smart sticky : masquer au scroll bas, réafficher au scroll haut */
        if (mode === 'smart') {
          if (y < threshold) {
            sectionEl.classList.remove('header--hidden');
            setFloatingCart(false);
          } else if (y > lastY + 6) {
            sectionEl.classList.add('header--hidden');
            setFloatingCart(true);
          } else if (lastY > y + 4) {
            sectionEl.classList.remove('header--hidden');
            setFloatingCart(false);
          }
        }

        lastY   = y;
        ticking = false;
      });
    }, { passive: true });
  })();

})();
